import PasswordInput from 'components/Inputs/PasswordInput'
import PasswordStrengthBar from 'components/PasswordStrengthBar'
import passwordValidator from 'validators/passwordValidator'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Row,
  Button,
  SubTitle,
  FormField,
  WarningText
} from '../styles'

export default function PasswordForm ({
  companyData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  return (
    <Formik
      validationSchema={passwordValidator}
      initialValues={{
        'password': companyData.password,
        'password_confirmation': companyData.password_confirmation
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onSubmit={handleSubmit} autoComplete='off' style={{ width: 400 }}>
          <SubTitle>Segurança</SubTitle>
          <Row>
            <FormField>
              <PasswordInput
                placeholder='Senha'
                value={values.password}
                onChange={handleChange ('password')}
                onBlur={handleBlur ('password')}
              />
              {touched.password && errors.password && (
                <WarningText>{errors.password}</WarningText>
              )}
              <PasswordStrengthBar password={values.password}/>
            </FormField>
          </Row>
          <Row>
            <FormField>
              <PasswordInput
                placeholder='Confirmar senha'
                value={values.password_confirmation}
                onChange={handleChange ('password_confirmation')}
                onBlur={handleBlur ('password_confirmation')}
              />
              {touched.password_confirmation && errors.password_confirmation && (
                <WarningText>{errors.password_confirmation}</WarningText>
              )}
            </FormField>
          </Row>
          <Button type='submit'>
            <MdNavigateNext size={30}/>
          </Button>
        </Form>
      )}
    </Formik>
  )
}
